import "./App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import ProtectedRoute from "./components/ProtectedRoute";
import SiteGate from "./components/SiteGate";

import Home from "./pages/Home";
import Marketplace from "./pages/Marketplace";
import ProductDetail from "./pages/ProductDetail";
import Producers from "./pages/Producers";
import ProducerDetail from "./pages/ProducerDetail";
import Clube from "./pages/Clube";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import TrackingPage from "./pages/TrackingPage";
import ClientDashboard from "./pages/dashboard/ClientDashboard";
import ReferralRedirect from "./pages/ReferralRedirect";
import AffiliateTracker, { captureVia } from "./components/AffiliateTracker";
import VendorDashboard from "./pages/dashboard/VendorDashboard";
import AdminDashboard from "./pages/dashboard/AdminDashboard";

export default function App() {
    // Captura ?via= imediatamente no carregamento inicial — ANTES do SiteGate.
    // Garante atribuição de afiliado mesmo em fase privada e em deep links.
    useEffect(() => {
        captureVia(window.location.search, window.location.pathname);
    }, []);

    return (
        <div className="App">
            <SiteGate>
                <AuthProvider>
                    <CartProvider>
                        <BrowserRouter>
                        <AffiliateTracker />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/marketplace" element={<Marketplace />} />
                            <Route path="/produto/:id" element={<ProductDetail />} />
                            <Route path="/produtores" element={<Producers />} />
                            <Route path="/produtores/:id" element={<ProducerDetail />} />
                            <Route path="/clube" element={<Clube />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/fornecedores/registo" element={<Register />} />
                            <Route path="/r/:code" element={<ReferralRedirect />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/carrinho" element={<Cart />} />
                            <Route
                                path="/checkout"
                                element={
                                    <ProtectedRoute>
                                        <Checkout />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/checkout/success" element={<CheckoutSuccess />} />
                            <Route path="/tracking/:code" element={<TrackingPage />} />
                            <Route
                                path="/conta/*"
                                element={
                                    <ProtectedRoute>
                                        <ClientDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/vendor/*"
                                element={
                                    <ProtectedRoute roles={["vendor"]}>
                                        <VendorDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/admin/*"
                                element={
                                    <ProtectedRoute roles={["admin"]}>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                        </Routes>
                        <Toaster
                            position="top-center"
                            toastOptions={{
                                style: {
                                    background: "#7A2A36",
                                    color: "#FBF8F3",
                                    border: "1px solid #D4A93C",
                                    borderRadius: "8px",
                                    fontFamily: "Manrope, sans-serif",
                                    fontSize: "13px",
                                    letterSpacing: "0.04em",
                                },
                            }}
                        />
                    </BrowserRouter>
                </CartProvider>
            </AuthProvider>
            </SiteGate>
        </div>
    );
}
